import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pinned-messages overflow-hidden"
}
const _hoisted_2 = {
  class: "d-flex align-items-center",
  style: {"min-height":"2.2em !important"}
}
const _hoisted_3 = { class: "close-icon action" }
const _hoisted_4 = {
  key: 0,
  class: "action text-right"
}

import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";
import {computed, ref} from "vue";
import {ChatTabStore, PinnedMessageInterface} from "~/chat/ts/store/ChatTab";
import ChatApiRequest from "~/chat/ts/service/request/ChatApiRequest";
import {__} from "~/ts/library/Translate";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "ChatPinnedMessage"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["show"],
  setup(__props, { emit: __emit }) {

let emits = __emit;

let lastDirection = ref(0);


let pinnedMessages = computed(() => ChatTabStore.pinnedMessages);

let pinnedMessageIndex = ref(0);

let computedPinnedMessageIndex = computed({
    get: () => {
        return Math.max(0, Math.min(pinnedMessageIndex.value, pinnedMessages.value.length - 1));
    },
    set: (value: number) => {
        pinnedMessageIndex.value = value;
    }
});

function changePinnedMessageIndex(delta: number) {
    lastDirection.value = delta;
    let value = computedPinnedMessageIndex.value + delta;
    let max = pinnedMessages.value.length - 1;
    if (value > max) {
        value = 0;
    } else if (value < 0) {
        value = max;
    }
    pinnedMessageIndex.value = value;
}

function unpin() {
    let messageId = pinnedMessages.value[computedPinnedMessageIndex.value].id;
    ChatTabStore.unpinMessage(messageId);
    ChatApiRequest.make({
        method: "unpinMessage",
        p: {
            messageId
        }
    });
}

return (_ctx: any,_cache: any) => {
  return (_unref(pinnedMessages).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (unpin()))
            }, [
              _createVNode(SvgIcon, {
                "icon-name": "times",
                title: _unref(__)('Открепить сообщение')
              }, null, 8, ["title"])
            ])
          ]),
          _createElementVNode("div", {
            class: "flex-fill cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(emits)('show', _unref(pinnedMessages)[_unref(computedPinnedMessageIndex)])))
          }, [
            _createVNode(_Transition, {
              name: _unref(lastDirection) == 1 ? 'list-down' : 'list-up'
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("div", {
                  class: "text-truncate",
                  key: _unref(pinnedMessages)[_unref(computedPinnedMessageIndex)].id
                }, _toDisplayString(_unref(pinnedMessages)[_unref(computedPinnedMessageIndex)].text), 1))
              ]),
              _: 1
            }, 8, ["name"])
          ]),
          (_unref(pinnedMessages).length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (changePinnedMessageIndex(-1)))
                  }, [
                    _createVNode(SvgIcon, { "icon-name": "chevron-up" })
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (changePinnedMessageIndex(1)))
                  }, [
                    _createVNode(SvgIcon, {
                      "icon-name": "chevron-up",
                      style: {"transform":"rotateX(180deg) !important"}
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})